import { render, staticRenderFns } from "./TaskCreateModal.vue?vue&type=template&id=42f10b16&scoped=true"
import script from "./TaskCreateModal.vue?vue&type=script&lang=js"
export * from "./TaskCreateModal.vue?vue&type=script&lang=js"
import style0 from "./TaskCreateModal.vue?vue&type=style&index=0&id=42f10b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f10b16",
  null
  
)

export default component.exports